export const dummyHoursData = [
  {
    "date": "2025-07-01",
    "actual_hours": 45.5,
    "planned_hours": 48.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-02",
    "actual_hours": 52.0,
    "planned_hours": 50.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-03",
    "actual_hours": 48.5,
    "planned_hours": 47.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-04",
    "actual_hours": 55.0,
    "planned_hours": 52.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-05",
    "actual_hours": 58.5,
    "planned_hours": 56.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-06",
    "actual_hours": 62.0,
    "planned_hours": 60.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-07",
    "actual_hours": 65.5,
    "planned_hours": 64.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-08",
    "actual_hours": 50.0,
    "planned_hours": 52.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-09",
    "actual_hours": 53.5,
    "planned_hours": 54.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-10",
    "actual_hours": 56.0,
    "planned_hours": 55.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-11",
    "actual_hours": 59.5,
    "planned_hours": 58.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-12",
    "actual_hours": 61.0,
    "planned_hours": 60.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-13",
    "actual_hours": 64.5,
    "planned_hours": 62.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-14",
    "actual_hours": 67.0,
    "planned_hours": 65.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-15",
    "actual_hours": 52.5,
    "planned_hours": 54.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-16",
    "actual_hours": 55.0,
    "planned_hours": 56.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-17",
    "actual_hours": 58.5,
    "planned_hours": 57.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-18",
    "actual_hours": 60.0,
    "planned_hours": 59.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-19",
    "actual_hours": 63.5,
    "planned_hours": 61.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-20",
    "actual_hours": 66.0,
    "planned_hours": 64.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-21",
    "actual_hours": 68.5,
    "planned_hours": 67.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-22",
    "actual_hours": 54.0,
    "planned_hours": 56.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-23",
    "actual_hours": 56.5,
    "planned_hours": 58.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-24",
    "actual_hours": 59.0,
    "planned_hours": 60.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-25",
    "actual_hours": 61.5,
    "planned_hours": 63.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-26",
    "actual_hours": 64.0,
    "planned_hours": 65.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-27",
    "actual_hours": 66.5,
    "planned_hours": 68.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-28",
    "actual_hours": 69.0,
    "planned_hours": 70.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-29",
    "actual_hours": 55.5,
    "planned_hours": 58.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-30",
    "actual_hours": 58.0,
    "planned_hours": 60.5,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  },
  {
    "date": "2025-07-31",
    "actual_hours": 60.5,
    "planned_hours": 63.0,
    "created_at": "2025-07-02T00:01:02.788Z",
    "updated_at": "2025-07-03T00:00:49.999Z"
  }
]; 